import {http} from "../_helpers";
import {axiosInstance} from "../_helpers/axiosInstance";

// SaaS billing - see specs/saas-subscription.md. Plain JSON bodies (not the Form helper):
// the managed-systems dialogs keep their own validation state.
const send = (method, url, data) => axiosInstance.request({method, url, data}).then(response => response.data);

class SubscriptionService {

    getStatus() {
        return http.get(`/subscription/status`);
    }

    getAdminInfo() {
        return http.get(`/subscription/admin-info`);
    }

    getManagedSystems() {
        return http.get(`/managed-systems`);
    }

    createManagedSystem(data) {
        return send('post', `/managed-systems`, data);
    }

    updateManagedSystem(id, data) {
        return send('put', `/managed-systems/${id}`, data);
    }

    topUp(id, data) {
        return send('post', `/managed-systems/${id}/top-up`, data);
    }

    adjust(id, data) {
        return send('post', `/managed-systems/${id}/adjust`, data);
    }

    sync(id) {
        return send('post', `/managed-systems/${id}/sync`);
    }

    getTransactions(id, page, size) {
        return http.get(`/managed-systems/${id}/transactions?page=${page}&size=${size}`);
    }
}

export default new SubscriptionService;
